// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Sy3U","importantInfo":"styles_importantInfo__3Hjhh"};